export const extractLastNameComponent = (name: string | undefined) => {
  if (name === undefined) {
    return undefined;
  }

  const parts = name.split('/');
  if (parts.length <= 0) {
    return name;
  }

  return parts[parts.length - 1];
};

export const extractLastNameComponentFromName = (name: string) => {
  const parts = name.split('/');
  return parts[parts.length - 1];
};

// TODO: move this to workflow package when created
// Extract the workflow type from a name with
// pattern `workflows/<type>/instances/<instance-id>`
export const extractWorkflowFromInstanceName = (name: string | undefined) => {
  if (name === undefined) {
    return undefined;
  }

  const parts = name.split('/');
  if (parts.length <= 0) {
    return name;
  }

  return parts[1];
};
